import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import Titulo from '../comum/Titulo';
import buscarVeiculos from '../../actions/veiculo/buscarVeiculos';
import excluirVeiculo from '../../actions/veiculo/excluirVeiculo';
import { alterouPagina } from '../../util/filtros';
import { getAdminEmpresa, getFiscalEmbarque, getOperadorEmpresa, PERFIL_ADMIN, getGestorOperacoes } from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import ModalCadastrarVeiculo from './ModalSelecionarMapaVeiculo';
import Veiculo from './Veiculo';
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import CampoSelecionarEmpresa from '../layout/CampoSelecionarEmpresa';
import PaginacaoVeiculos from './PaginacaoVeiculos';
import BotoesPaginacaoVeiculos from './BotoesPaginacaoVeiculos';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import ModalLocalizacaoVeiculo from './ModalLocalizacaoVeiculo';
import filtrarResumoVeiculo from '../../actions/veiculo/filtrarResumoVeiculo';
import selecionarVeiculo from '../../actions/veiculo/selecionarVeiculo';
import alterarMapaSelecionadoVeiculo from '../../actions/veiculo/alterarMapaSelecionadoVeiculo';

export const CabecalhoTabela = () => (
    <div className="vx-list-header vx-list-header--veiculo">
        <div className="vx-list-header-cell"></div>
        <div className="vx-list-header-cell">Imagem</div>
        <div className="vx-list-header-cell">Descrição</div>
        <div className="vx-list-header-cell">Qtd. Assentos</div>
        <div className="vx-list-header-cell">Ações</div>
    </div>
);

const ModalConfirmacaoExclusaoVeiculo = ({ excluir, veiculo }) => (
    <div className="modal fade" id="modalConfirmacaoExclusaoVeiculo" tabIndex="-1" role="dialog"
        aria-labelledby="modalConfirmacaoExclusaoVeiculo" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
            <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                <div className="vx-modal-header">
                    <div className="vx-modal-title">
                        <span className="material-icons">delete</span>
                        Excluir Veículo
                    </div>
                </div>
                <div className="vx-modal-body" style={{ background: '#fff', textAlign: 'center' }}>
                    <p style={{ margin: 0, fontSize: 14, color: '#444' }}>
                        Deseja excluir o veículo <strong>{veiculo ? veiculo.descricao : ''}</strong>?
                    </p>
                </div>
                <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">Cancelar</button>
                    <button type="button" className="vx-modal-btn-confirmar" data-dismiss="modal"
                        onClick={() => excluir()}>
                        <span className="material-icons" style={{ fontSize: 15 }}>delete</span>
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    </div>
);

export class PainelGerenciarVeiculos extends React.Component {
    constructor(props) {
        super(props);
        this.selecionarVeiculo = this.selecionarVeiculo.bind(this);
        this.limparCampos = this.limparCampos.bind(this);
        this.excluir = this.excluir.bind(this);
        this.submeterBusca = this.submeterBusca.bind(this);
        this.state = {
            veiculoSelecionado: null,
            textoFiltro: null,
            empresaSelecionada: null,
        };
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
        }
    }

    componentDidUpdate(prevProps) {
        if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
            this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
        }
    }

    limparveiculoSelecionado() {
        this.setState({ veiculoSelecionado: null });
    }

    excluir() {
        this.props.excluirVeiculo(this.state.veiculoSelecionado.id, this.props.empresaSelecionada.id)
            .then(() => {
                this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
                this.limparveiculoSelecionado();
            });
    }

    submeterBusca(event) {
        this.props.filtrarResumoVeiculo(this.props.resumoVeiculo, event.target.value);
    }

    limparCampos() {
        this.props.changeFieldValue('formularioPainelCadastroVeiculo', 'mapaVeiculo', '');
        this.props.changeFieldValue('formularioPainelCadastroVeiculo', 'idVeiculo', '');
        this.props.changeFieldValue('formularioPainelCadastroVeiculo', 'descricao', '');
        this.limparveiculoSelecionado();
    }

    selecionarVeiculo(veiculo) {
        this.setState({ veiculoSelecionado: veiculo });
        this.props.selecionarVeiculo(veiculo);
    }

    exibirTabelaVeiculos() {
        if (!this.props.empresaSelecionada) return null;

        if (this.props.veiculos && this.props.veiculos.length) {
            return (
                <div className="vx-list-container">
                    <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoVeiculos}
                        BotoesPaginacao={BotoesPaginacaoVeiculos}>
                        <CabecalhoTabela />
                        {this.exibirVeiculos()}
                    </CabecalhoRodapeTabela>
                </div>
            );
        }
        return (
            <div className="vx-list-container">
                <div className="vx-empty-state">
                    <span className="material-icons">directions_bus</span>
                    <p>Nenhum veículo cadastrado para a empresa selecionada.</p>
                </div>
            </div>
        );
    }

    exibirVeiculos() {
        return this.props.veiculos.map((veiculo, index) => (
            <Veiculo key={index} veiculo={veiculo} selecionar={this.selecionarVeiculo} indice={index} />
        ));
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[
                PERFIL_ADMIN,
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id),
            ]}>
                <div className="container-padrao">
                    <Titulo texto="Gerenciar Veículos" urlRetorno="/" />

                    <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                        <div style={{ maxWidth: 340, marginBottom: 16 }}>
                            <CampoSelecionarEmpresa />
                        </div>
                    </Autorizacao>

                    <Autorizacao perfisPermitidos={[
                        PERFIL_ADMIN,
                        getAdminEmpresa(this.props.empresaSelecionada.id),
                        getGestorOperacoes(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                    ]}>
                        <div className="vx-page-toolbar" style={{ marginBottom: 12 }}>
                            <span />
                            <button type="button" className="vx-toolbar-btn"
                                onClick={() => {
                                    this.props.selecionarVeiculo(null);
                                    this.props.alterarMapaSelecionadoVeiculo(null);
                                    this.props.history.push('/painel-cadastro-veiculo');
                                }}>
                                <span className="material-icons" style={{ fontSize: 16 }}>add</span>
                                Novo Veículo
                            </button>
                        </div>
                    </Autorizacao>

                    {this.exibirTabelaVeiculos()}
                </div>

                <ModalCadastrarVeiculo veiculo={this.state.veiculoSelecionado} />
                <ModalConfirmacaoExclusaoVeiculo excluir={this.excluir} veiculo={this.state.veiculoSelecionado} />
                <ModalLocalizacaoVeiculo />
            </Autorizacao>
        );
    }
}

export const mapStateToProps = state => ({
    veiculos: state.veiculos.veiculos,
    resumoVeiculo: state.veiculos.resumoVeiculo,
    empresaSelecionada: state.empresaSelecionada,
    paginaAtual: state.paginaAtualVeiculo,
    registrosPorPagina: state.registrosPorPaginaVeiculo,
    changeFieldValue,
});

export default connect(mapStateToProps, {
    buscarVeiculos,
    excluirVeiculo,
    filtrarResumoVeiculo,
    selecionarVeiculo,
    alterarMapaSelecionadoVeiculo,
})(reduxForm({
    form: 'formularioPainelCadastroVeiculo',
})(PainelGerenciarVeiculos));
